// extracted by mini-css-extract-plugin
module.exports = {"root":"RightPrivateNav_root__2F4Ce","tab":"RightPrivateNav_tab__z5GgG"};